import { Component, Input, OnInit } from "@angular/core";
import { LANGUAGE } from "@prequalification/models";
import { SupportedLocale } from "@rig/common";
import { Observable } from "rxjs";


@Component({
  selector: "pre-qualification",
  templateUrl: "./pre-qualification.component.html",
  styleUrls: ["./pre-qualification.component.scss"]
})
export class PreQualificationComponent implements OnInit{
  @Input() cardName = "";
  @Input() productCode = "";
  @Input() submitted = false;
  @Input() locale: SupportedLocale = LANGUAGE.EN as SupportedLocale;
  @Input() isMobile$: Observable<boolean>;

  isPremiumCard = false;
  isWestJet = false;

  ngOnInit(): void {
      this.isPremiumCard = this.productCode === 'MCB' || this.productCode === 'AIB';
      this.isWestJet = this.productCode === 'MCB';
  }
  
  goToWestjetSignup() {
    if (this.locale === 'en') {
      window.open('https://www.westjet.com/en-ca/rewards/join');
    } else {
      window.open('https://www.westjet.com/fr-ca/rewards/join');
    }
  }

}

